export default "__VITE_ASSET__ae84e4a1__"